export default {
  name: 'MainSchoolSelectModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    closable: {
      type: Boolean,
      default: true
    },
    keyword: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    schools: {
      type: Array,
      default: () => []
    },
    currentSchoolId: {
      type: [String, Number],
      default: ''
    }
  },
  methods: {
    handleKeywordInput(value) {
      const inputValue = value && value.target ? value.target.value : value
      this.$emit('keyword-change', typeof inputValue === 'string' ? inputValue.trim() : '')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/main/components/SchoolSelectModal/index.js